import { AnyAction, Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { TGiftCardAPIPayload } from 'types/gift-card';

import * as types from './ActionTypes';
import api from './ApiActions';

export function purchaseGiftCard({
  client_name,
  client_email,
  client_phone,
  sender_name,
  sender_email,
  sender_phone,
  value,
  slug,
  token,
}: TGiftCardAPIPayload) {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch({
      type: types.PURCHASE_GIFT_CARD_REQUEST,
    });

    try {
      void dispatch(
        api.post('/gift_cards', {
          params: {},
          data: {
            id: slug,
            client_name,
            client_email,
            client_phone,
            sender_name,
            sender_email,
            sender_phone,
            value,
            stripe_token: token,
          },
          request: types.PURCHASE_GIFT_CARD_REQUEST,
          success: types.PURCHASE_GIFT_CARD_SUCCESS,
          failure: types.PURCHASE_GIFT_CARD_FAILURE,
        }),
      );
    } catch (e: any) {
      dispatch({
        type: types.PURCHASE_GIFT_CARD_FAILURE,
        payload: { error: e.error.message },
      });
    }
  };
}

export function startGiftCardFormLoading() {
  return {
    type: types.GIFT_CARD_FORM_LOADING_START,
  };
}

export function stopGiftCardFormLoading() {
  return {
    type: types.GIFT_CARD_FORM_LOADING_STOP,
  };
}

export function resetGiftCardState() {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch({
      type: types.RESET_GIFT_CARD_STATE,
    });
  };
}
